import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { SCREEN_PATHS } from "../../../constants";

export const OverviewRedirect = (): JSX.Element => {
  const { estateId } = useParams();
  return <Navigate to={`${SCREEN_PATHS.estates}/${estateId}`} replace={true} />;
};
